module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "chapterPicker",
    staticClass: "chapter-picker"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptions
    },
    on: {
      "click": _vm.selectChapter
    }
  }, [_vm._l((_vm.items.slice().reverse()), function(item, index) {
    return _c('swiper-slide', {
      key: index + 1,
      staticClass: "chapter-item",
      class: _vm.selectedChapter === item.id ? 'selected' : '',
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "supertitle"
    }, [_vm._v("MONS " + _vm._s(index + 1) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.chapterTranslations[0].title))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-447555ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ChapterPicker.vue
// module id = 505
// module chunks = 1